import {cx} from '@emotion/css';
import React, {ReactElement} from 'react';
import {useLocale} from '../../../../RootProvider/LocaleContext';
import Paragraph from '../../../DesignSystem/Text/Paragraph/Paragraph';
import styles from './CalculatorResultItem.styles';

interface Props {
  title: string;
  value?: string;
  bordered?: boolean;
  template?: (templateValue: string) => string;
}

function CalculatorResultItem({
  title,
  value,
  bordered,
  template = (templateValue: string) => templateValue,
}: Props): ReactElement {
  const locale = useLocale();
  const defaultValue = '-';

  const getValue = () => {
    if (value?.length) {
      const formattedValue = Number(value).toLocaleString(locale, {useGrouping: true});
      return template(formattedValue);
    }

    return defaultValue;
  };

  return (
    <div className={cx(styles.calculatorResult(bordered))}>
      <Paragraph className={cx(styles.title)}>{title}</Paragraph>
      <Paragraph className={cx(styles.value)}>{getValue()}</Paragraph>
    </div>
  );
}

export default CalculatorResultItem;
